import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { AiFillCaretDown } from "react-icons/ai";

interface Network {
  id: string;
  title: string;
  network: string;
  image: string;
}

interface RootState {
  networks: Network[];
}
const BridgeRightDropdown = () => {
  const networks = useSelector((state: RootState) => state.networks);

  const [selectedValue, setSelectedValue] = useState<Network | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: { target: any }) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionClick = (network: React.SetStateAction<Network | null>) => {
    setSelectedValue(network);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const initialSelectedValue = localStorage.getItem("selectedNetwork");
    if (initialSelectedValue) {
      setSelectedValue(JSON.parse(initialSelectedValue));
    } else {
      setSelectedValue(networks[0]);
    }

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [networks]);

  return (
    <div className="relative inline-block w-full flex-1" ref={dropdownRef}>
      <div
        className="bg-transparent_100 rounded-3xl flex items-center gap-4 w-full p-2 px-3 relative cursor-pointer"
        onClick={toggleDropdown}
      >
        <div className="text-white">
          {selectedValue && (
            <div className="flex items-center gap-3">
              <div className="flex justify-center items-center w-10 h-10 border border-transparent_200 rounded-xl">
                <img
                  src={selectedValue.image}
                  alt={`Logo of ${selectedValue.title}`}
                  className="h-4"
                />
              </div>
              <div className="flex flex-col">
                <h4 className="text-sm font-medium">{selectedValue.title}</h4>
                <span className="text-10 text-opacity-50">
                  {selectedValue.network}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="ml-2">
          {isDropdownOpen ? (
            <AiFillCaretDown className="absolute right-4 top-7 w-4 text-white" />
          ) : (
            <AiFillCaretDown className="absolute right-4 top-7 w-4 text-white" />
          )}
        </div>
      </div>

      {isDropdownOpen && (
        <ul className="bg-drawer_bg rounded-3xl flex flex-col gap-1 w-full cursor-pointer z-10 absolute top-16 h-48 overflow-y-auto scrollbar-hide">
          {networks.map((network) => (
            <li
              key={network.id}
              onClick={() => handleOptionClick(network)}
              className="rounded-3xl flex items-center gap-4 w-full p-2 px-3 hover-bg-transparent_600 hover:bg-transparent_600 transition duration-200"
            >
              <div className="text-white">
                <div className="flex items-center gap-3">
                  <div className="flex justify-center items-center w-10 h-10 border border-transparent_200 rounded-xl">
                    <img
                      src={network.image}
                      alt={`Logo of ${network.title}`}
                      className="h-4"
                    />
                  </div>
                  <div className="flex flex-col">
                    <h4 className="text-sm font-medium">{network.title}</h4>
                    <span className="text-10 text-opacity-50">
                      {network.network}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BridgeRightDropdown;
